import { useTranslation } from 'react-i18next';
import { DescriptionBar, FoldingDescription } from 'components';
import { faqList } from './utils';
import { Helmet } from 'react-helmet-async';

const FAQ = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('faq.pageTitle')} | IOPS SPACE</title>
        <meta name="description" content={t('faq.pageDescription')} />
      </Helmet>
      <div className="w-full max-w-[800px]">
        <DescriptionBar
          className="mb-4 md:mb-2"
          title={t('faq.pageTitle')}
          description={t('faq.pageDescription')}
        />
        <div className="flex w-full flex-col gap-10 px-4 py-6 md:px-3">
          {faqList.map(({ title, description }, index) => (
            <FoldingDescription
              key={`${title}_${index}`}
              title={t(title)}
              description={t(description)}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default FAQ;
